import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import CustomerPan from './customerPan';

const KYCDetails: React.FC = () => (
  <Card className="pb-3">
    <Card.Body className="p-5 pb-0">
      <Card.Title>KYC Details</Card.Title>
      <Row>
        <Col md={6} sm={12} className="px-2">
          <CustomerPan />
        </Col>
        <Col md={6} sm={12}>
          {/* <CustomerAadhaar /> */}
        </Col>
      </Row>
    </Card.Body>
  </Card>
);

export default KYCDetails;
